import React from 'react';
import { NextArrow, PrevArrow } from '../../molecules/CustomArrows';

const carouselSettings = (config = {}) => ({
  dots: true,
  dotsClass: 'slick-dots slick-thumb',
  // setting infinite false to prevent
  // slick for making slide clones
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: <NextArrow color="default" />,
  prevArrow: <PrevArrow color="default" />,
  arrows: true,
  lazyLoad: 'progressive',
  speed: 500,
  ...config,
});

export default carouselSettings;
